import { DraftConfiguration } from '@/types';

export const getSortedConfigurations = (
  configurations: DraftConfiguration[],
  configurationIds: number[]
) => {
  const indexMap = new Map(
    configurations.map((configuration) => [
      configuration,
      configurationIds.indexOf(configuration.cid),
    ])
  );

  return configurations.sort((a, b) => indexMap.get(a)! - indexMap.get(b)!);
};
